<div class="flex flex-auto flex-col items-center justify-between">
    <!-- Logo -->
    <app-startup-logo (dblclick)="privateLogin()"> </app-startup-logo>

    <!-- <form
        [formGroup]="firebaseTokenForm"
        *ngIf="isPrivateLogin"
        class="bg-card absolute mt-20 flex translate-x-[-300px] flex-col items-start gap-1 rounded-md p-2 shadow-md"
    >
        <p class="font-bold text-gray-700">
            Login for development purposes only
        </p>
        <label for="">Enter jwt :</label>
        <input class="input" formControlName="token" />
        <button (click)="enterFirebaseToken()" class="btn btn-primary mt-2">
            Login
        </button>
    </form> -->

    <div class="start-up-form-container">
        <div class="min-w-full">
            <!-- Title -->
            <div class="start-up-title">Welcome back</div>

            <!-- Alert -->
            @if (showAlert) {
                <fuse-alert
                    class="mt-2"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'"
                >
                    {{ alert.message }}
                </fuse-alert>
            }

            <!-- Sign in form -->
            <form class="mt-3" [formGroup]="signInForm" #signInNgForm="ngForm">
                <!-- Email field -->
                <mat-form-field class="mat-form-field-cleaner">
                    <mat-label class="text-md font-bold">Email</mat-label>
                    <input
                        class="input"
                        id="email"
                        matInput
                        [formControlName]="'email'"
                    />
                    @if (signInForm.get('email').hasError('required')) {
                        <mat-error> Email address is required </mat-error>
                    }
                    @if (signInForm.get('email').hasError('email')) {
                        <mat-error>
                            Please enter a valid email address
                        </mat-error>
                    }
                </mat-form-field>

                <!-- Password field -->
                <mat-form-field class="mat-form-field-cleaner relative">
                    <mat-label class="text-md font-bold">Password</mat-label>
                    <div class="relative flex flex-row justify-between">
                        <input
                            class="input"
                            id="password"
                            matInput
                            type="password"
                            [formControlName]="'password'"
                            #passwordField
                        />
                        <button
                            mat-icon-button
                            type="button"
                            (click)="
                                passwordField.type === 'password'
                                    ? (passwordField.type = 'text')
                                    : (passwordField.type = 'password')
                            "
                            class="absolute -top-1.5 right-1"
                            matSuffix
                        >
                            @if (passwordField.type === 'password') {
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_solid:eye'"
                                ></mat-icon>
                            }
                            @if (passwordField.type === 'text') {
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_solid:eye-slash'"
                                ></mat-icon>
                            }
                        </button>
                    </div>
                    <mat-error> Password is required </mat-error>
                </mat-form-field>

                <!-- Actions -->
                <div class="start-up-actions-container">
                    <mat-checkbox
                        class="-ml-2"
                        [color]="'primary'"
                        [formControlName]="'rememberMe'"
                    >
                        <p class="font-bolder text-md text-gray-500">
                            Remember Me
                        </p>
                    </mat-checkbox>
                    <a
                        class="start-up-forgot-password"
                        [routerLink]="['/forgot-password']"
                        >Forgot password?
                    </a>
                </div>

                <!-- Submit button -->
                <button
                    class="btn btn-primary btn-login"
                    [disabled]="signInForm.disabled"
                    (click)="signIn()"
                >
                    @if (!signInForm.disabled) {
                        <span class="flex-auto text-xl"> Login </span>
                    }
                    @if (signInForm.disabled) {
                        <mat-progress-spinner
                            class="mx-auto"
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>

                <!-- Social Media Login -->
                <!-- Separator -->
                <!-- <div class="mt-8 flex items-center">
                    <div class="mt-px flex-auto border-t"></div>
                    <div class="text-secondary mx-2">Or continue with</div>
                    <div class="mt-px flex-auto border-t"></div>
                </div> -->

                <!-- Single sign-on buttons -->
                <!-- <div class="mt-8 flex items-center space-x-4">
                    <button class="flex-auto" type="button" mat-stroked-button>
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'feather:facebook'"
                        ></mat-icon>
                    </button>
                    <button class="flex-auto" type="button" mat-stroked-button>
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'feather:twitter'"
                        ></mat-icon>
                    </button>
                    <button class="flex-auto" type="button" mat-stroked-button>
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'feather:github'"
                        ></mat-icon>
                    </button>
                </div> -->
            </form>
        </div>
    </div>

    <!-- Copyright -->
    <app-copyright></app-copyright>
</div>
